import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AddGroupArticles, AddGroupArticlesError, AddGroupArticlesSuccess, DeleteGroupArticles, DeleteGroupArticlesError, DeleteGroupArticlesSuccess, GroupsArticlesByGestiuneIdError, GroupsArticlesByGestiuneIdLoaded, GroupsArticlesByGestiuneIdRequested, GroupsArticlesError, GroupsArticlesLoaded, GroupsArticlesRequested, UpdateGroupArticles, UpdateGroupArticlesError, UpdateGroupArticlesSuccess } from './groupsArticles.actions';
import { ClientService } from '../../@core/data/clients/client.service';
import { co } from '@fullcalendar/core/internal-common';
import { ToastrConfigs } from '../../@core/data/toastr-config';
import { NbToastrService } from '@nebular/theme';
import { ArticleGroupService } from '../../@core/data/groups-articles/groupsArticles.service';


@Injectable()
export class GroupsArticlesEffects {
  constructor(
    private actions$: Actions,
    private groupArticlesService: ArticleGroupService,
    private toastrService: NbToastrService
  ) {}

  requestGroupsArticles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GroupsArticlesRequested),
      mergeMap(() =>
        this.groupArticlesService.getArticleGroups().pipe(
          map((res: any) => { 
            return GroupsArticlesLoaded({ groupsArticles: res?.data })}),
          catchError((error: any) => of(GroupsArticlesError()))
        ) 
      )
    )
  );

  requestGroupsArticlesByGestiuneId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GroupsArticlesByGestiuneIdRequested),
      mergeMap(({ gestiuneId }) =>
        this.groupArticlesService.getArticleGroups(gestiuneId).pipe(
          map(res =>
            GroupsArticlesByGestiuneIdLoaded({
              gestiuneId,
              groupsArticles: res.data ?? [],
            })
          ),
          catchError(() => of(GroupsArticlesByGestiuneIdError()))
        )
      )
    )
  );


  addGroupArticles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddGroupArticles),
      mergeMap((action) =>
        this.groupArticlesService.saveArticleGroup(action.groupsArticles).pipe(
          map((response: any) => {
            const groupArticlesWithId = { ...response.data };
            this.toastrService.success('Grupă articole salvată cu succes', 'Success', { ...ToastrConfigs.success });
            return AddGroupArticlesSuccess({ groupsArticles: groupArticlesWithId });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare salvare grupă articole', 'Error', { ...ToastrConfigs.danger });
            return of(AddGroupArticlesError());
          })
        )
      )
    )
  );
  updateGroupArticles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateGroupArticles),
      mergeMap((action) =>
        this.groupArticlesService.updateArticleGroup(action.groupsArticles).pipe(
          map((response: any) => {
            const updatedGroupArticles = { ...response.data };
            if (!action.skipToast) {
              this.toastrService.success('Grupă articole actualizată cu succes', 'Success', { ...ToastrConfigs.success });
            }
            return UpdateGroupArticlesSuccess({ groupsArticles: updatedGroupArticles  });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare actualizare grupă articole', 'Error', { ...ToastrConfigs.danger });
            return of(UpdateGroupArticlesError());
          })
        )
      )
    )
  );

  deleteGroupArticles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteGroupArticles),
      mergeMap(action =>
        this.groupArticlesService.deleteArticleGroup(action.id).pipe(
          map((response: any) => {
            if (!response.status) {
              this.toastrService.danger(
                response.message || 'Eroare ștergere grupă articole',
                'Error',
                { ...ToastrConfigs.danger }
              );
              return DeleteGroupArticlesError();
            }
            this.toastrService.success(
              'Grupă articole ștearsă cu succes',
              'Success',
              { ...ToastrConfigs.success }
            );
            return DeleteGroupArticlesSuccess({ id: action.id });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare ștergere grupă articole', 'Error', { ...ToastrConfigs.danger });
            return of(DeleteGroupArticlesError());
          })
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GroupsArticlesError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
